import React from 'react';
import {Field} from 'react-final-form';
import usePrice from '../../hooks/usePrice';
import PropTypes from 'prop-types';
import useCalculator from '../../hooks/useCalculator';
import {FEATURE_PRICE_TYPE_PRICE_PER_SOURCE} from '../../constants/FeaturePriceTypeConstant';

function FeatureField({name, feature, tooltip}) {
    const {priceFormat} = usePrice();
    const {calculateFeaturePrice} = useCalculator();

    if (!feature.enable) {
        return null;
    }

    const isFree = feature && feature.type === FEATURE_PRICE_TYPE_PRICE_PER_SOURCE;

    return (<div className="toggle-switch-wrap">
            <label className="switch">
                <Field name={name}>
                    {({input}) => (<input
                            type="checkbox"
                            checked={Number(input.value) === 1}
                            onChange={(e) => {
                                input.onChange(e.target.checked ? 1 : 0);
                            }}
                        />)}
                </Field>
                <span className="switch-slider round">
                    <div className="switch-slider__icon">
                        <img src="/_core/assets/themes/v5/assets/img/form3/switch-icon.svg" alt=""/>
                    </div>
                </span>
            </label>
            <div className="switch-text">
                <div className="switch-label d-flex">
                    {feature.label}
                    {tooltip}
                </div>
                {feature.showPrice && (<div className="switch-price">
                        {isFree ? 'Free' : (<React.Fragment>
                                <span>{priceFormat(calculateFeaturePrice(feature, true))} </span>
                                {feature.isVipSupport ? '' : feature.typeLabel}
                            </React.Fragment>)}
                    </div>)}
            </div>
        </div>);
}

FeatureField.propTypes = {
    name: PropTypes.string.isRequired,
    feature: PropTypes.object.isRequired,
    tooltip: PropTypes.any,
}

export default FeatureField;